import * as z from 'zod/v4'

// Mirrors the backend tool-result ACK contract (ClientToolStatus / LlmToolResultPart in
// services/common-backend/src/llm-clients/llm_message_client.ts): the client echoes the
// LLM-assigned toolCallId, reports a status the model can branch on, and passes an opaque
// data payload back into the next turn.
export const ClientToolStatusSchema = z.enum(['SUCCESS', 'ERROR', 'TOOL_NOT_AVAILABLE', 'TOOL_DENIED'])

export type ClientToolStatus = z.infer<typeof ClientToolStatusSchema>

export const CommandResponseSchema = z.strictObject({
  toolCallId: z.string(),
  status: ClientToolStatusSchema,
  data: z.record(z.string(), z.unknown()).optional()
})

export type CommandResponse = z.infer<typeof CommandResponseSchema>
